import { useEffect, type ReactNode } from "react";

import { useTheme } from "@/hooks/useTheme";

/**
 * Applies `resolvedTheme` (from `useTheme`, src/hooks/useTheme.ts) to
 * `<html>` as the `dark` class, which is what tailwind.config.ts's
 * `darkMode: ["class"]` and every CSS variable in globals.css key off of.
 * This is the only place that touches `document.documentElement.classList`
 * for theme purposes — components never toggle it directly, they just read
 * `useTheme()`.
 *
 * Mounted once, near the root (see src/app/AppProviders.tsx); it renders
 * `children` unchanged and does its work entirely through the effect below.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    document.documentElement.classList.toggle("dark", resolvedTheme === "dark");
  }, [resolvedTheme]);

  return children;
}
